import axios from "axios";

export default {
	listAssessments(ctx) {
		return axios.get("/v3/assessments", {
			params: ctx
		});
	},
	listPublicAssessments(refID) {
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_assessments/${refID}`, config);
	},
	getPublicAssessment(taskID){
		let config = {};
		config.headers = { "X-No-Timeout": true };
		return axios.get(`/v3/public_assessment/${taskID}`,config);
	},
	listTempAssessments(ctx) {
		return axios.get("/v3/temp_assessments", {
			params: ctx
		});
	},
	listMyAssessments() {
		return axios.get("/v3/assessments/mine");
	},
	getRefIDs() {
		return axios.get("/v3/assessments/refids");
	},
	getSuggestedAssessments(num) {
		return axios.get("/v3/assessments/suggested", {
			params: { num: num }
		});
	},

	getClassAssessment(classID, asmtID) {
		return axios.get(`/v3/class/${classID}/assessment/${asmtID}`);
	},

	getClassAssessmentWork(classID, asmtID) {
		return axios.get(`/v3/class/${classID}/assessment/${asmtID}/work`);
	},

	getEmailRequestStats(classID, asmtID, deliveryID) {
		return axios.get(
			`/v3/email_requests/${classID}/${asmtID}/${deliveryID}`
		);
	},

	sendEmailRequests(classID, asmtID, deliveryID, studentIDs) {
		return axios.post(
			`/v3/email_requests/${classID}/${asmtID}/${deliveryID}/send`,
			studentIDs
		);
	},

	getAssessment(id) {
		return axios.get(`/v3/assessment/${id}`);
	},
	getTempAssessment(id) {
		return axios.get(`/v3/temp_assessment/${id}`);
	},
	getTempAssessment(id) {
		return axios.get(`/v3/temp_assessment/${id}`);
	},
	getAssessmentStat(id) {
		return axios.get(`/v3/assessmentsstat/${id}`);
	},
	isScored(id) {
		return axios.get(`/v3/admin/assessment_scored/${id}`);
	},

	saveAssessment(item) {
		return axios.post("/v3/admin/assessments", item);
	},
	saveTempAssessment(item) {
		return axios.post("/v3/admin/temp_assessments", item);
	},
	removeAssessment(id) {
		return axios.delete(`/v3/admin/assessment/${id}`);
	},
	removeTempAssessment(id) {
		return axios.delete(`/v3/admin/temp_assessment/${id}`);
	},

	pinAssessment(asmtID) {
		return axios.post(`/v3/assessment/${asmtID}/pin`);
	},

	unpinAssessment(asmtID) {
		return axios.post(`/v3/assessment/${asmtID}/unpin`);
	},

	activateAssessment(asmtID) {
		return axios.post(`/v3/assessment/${asmtID}/activate`);
	},
	activateTempAssessment(asmtID) {
		return axios.post(`/v3/temp_assessment/${asmtID}/activate`);
	},
	deactivateAssessment(asmtID) {
		return axios.post(`/v3/assessment/${asmtID}/deactivate`);
	},

	getRemainingResponses(ids) {
		return axios.get(`/v3/assessments/remaining`, { params: { ids: ids } });
	},
	pullAssignmentAction(asigID,asigTime){
		return axios.delete(`/v3/assessmentsaction/${asigID}/${asigTime}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/AssessmentService.js